import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { NavService } from 'src/app/services/nav.service';
const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';

@Component({
  selector: 'app-full',
  templateUrl: './full.component.html',
  // styleUrls: ['./full.component.scss'],
})
export class FullComponent implements OnInit, OnDestroy,AfterViewInit {
  @ViewChild('leftsidenav') public sidenav: MatSidenav;
  ngAfterViewInit() {
    this.navService.setSidenav(this.sidenav); // Set the sidenav reference in NavService
  }

  private layoutChangesSubscription = Subscription.EMPTY;
  public isOver: boolean = false; // Define the property
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  

  constructor(private breakpointObserver: BreakpointObserver,private navService: NavService) {}

  ngOnInit(): void {
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW])
      .subscribe((state) => {
        this.isOver = state.breakpoints[MOBILE_VIEW]; // Update isOver for mobile view
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
      });
  }

  ngOnDestroy(): void {
    this.layoutChangesSubscription.unsubscribe();
  }
  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
  }

  toggleCollapsed(): void {
    this.isContentWidthFixed = false;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape' && this.sidenav && this.sidenav.opened) {
      event.preventDefault(); // Prevent default behavior of closing sidenav
      console.log('Esc key pressed, but sidenav will not close.');
    }
  }
}
